export class DialogData {
    title: string;
    body: string;
    type: number;
    showCancel: boolean;
}
